import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import DemoRedirect from './components/DemoRedirect';
import BlogIndex from './components/BlogIndex';
import BlogPost from './components/BlogPost';
import ServicePage from './components/ServicePage';
import LocationPage from './components/LocationPage';

// Split out of the main bundle. Everything above stays eagerly imported because
// react-snap prerenders those routes (see `reactSnap.include` in package.json) and a
// lazy boundary there would change the prerendered HTML. Neither route below is
// prerendered, and nothing on the marketing site links to /admin — so this moves the
// whole admin app (Firebase auth, debt tracker, wealth simulations, admin console) out
// of the bundle every marketing visitor downloads, with no effect on those pages.
const Admin = lazy(() => import('./components/Admin'));
const PayConfirm = lazy(() => import('./components/PayConfirm'));
const SetPassword = lazy(() => import('./components/SetPassword'));

function RouteFallback() {
  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div
        style={{
          width: 40, height: 40, border: '4px solid #6b4d96', borderTopColor: 'transparent',
          borderRadius: '50%', animation: 'spin 1s linear infinite',
        }}
      />
      <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="/demo" element={<DemoRedirect />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/software-development-san-francisco" element={<LocationPage />} />
        <Route path="/software-development-atlanta" element={<LocationPage />} />
        <Route path="/pay-confirm/:token" element={<PayConfirm />} />
        {/* Where an invited person lands from their setup email. Not prerendered — it is
            meaningless without the oobCode Firebase appends to the link. */}
        <Route path="/set-password" element={<SetPassword />} />
        {/* Catch-all route for unmatched paths - redirect to home */}
        <Route path="*" element={<Home />} />
      </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
